//TODO : Refactor after ai
import { useEffect, useRef, useState } from "react";
import type { HTMLAttributes } from "react";
import type { SortDirection, SortField } from "./types";

export interface SortControlProps extends HTMLAttributes<HTMLDivElement> {
  fields?: SortField[];
  field?: string;
  direction?: SortDirection;
  onFieldChange?: (field: string) => void;
  onDirectionChange?: (direction: SortDirection) => void;
  label?: string;
}

/** Sort field picker plus a direction toggle. */
export function SortControl({
  fields = [],
  field,
  direction = "asc",
  onFieldChange,
  onDirectionChange,
  label = "Sortieren",
  className = "",
  ...rest
}: SortControlProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const away = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", away);
    return () => document.removeEventListener("mousedown", away);
  }, []);

  const current = fields.find((f) => f.value === field);
  const dirLabel = direction === "asc" ? "Aufsteigend" : "Absteigend";

  return (
    <div
      ref={ref}
      className={className}
      style={{ position: "relative", display: "inline-flex" }}
      {...rest}
    >
      <div className="bui-ov-sort">
        <button
          type="button"
          className="bui-ov-sort__field"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M7 4v16M7 20l-3.5-3.5M7 20l3.5-3.5" />
            <path d="M14 7h7M14 12h5M14 17h3" />
          </svg>
          {current ? current.label : label}
        </button>
        <button
          type="button"
          className="bui-ov-sort__dir"
          title={dirLabel}
          aria-label={dirLabel}
          onClick={() => onDirectionChange?.(direction === "asc" ? "desc" : "asc")}
        >
          <svg
            width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
            style={{ transform: direction === "asc" ? "none" : "rotate(180deg)" }}
          >
            <path d="M12 20V4M12 4 6 10M12 4l6 6" />
          </svg>
        </button>
      </div>
      {open && (
        <div
          className="bui-menu"
          style={{ position: "absolute", top: "100%", right: 0, marginTop: 6, zIndex: 25, minWidth: 200 }}
        >
          {fields.map((f) => (
            <button
              key={f.value}
              type="button"
              className="bui-menu__item"
              data-selected={f.value === field || undefined}
              onClick={() => {
                onFieldChange?.(f.value);
                setOpen(false);
              }}
            >
              {f.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
